<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><em class="italic">InterVarsity Press, USA</em></p>
<p class="copyright"><em class="italic">P.O. Box 1400<br/>Downers Grove, IL 60515, USA </em></p>
<p class="copyright"><em class="italic"><a class="www" href="http://www.ivpress.com" target="_blank">ivpress.com</a></em></p>
<p class="copyright"><em class="italic"><a class="www" href="mailto:email@ivpress.com">email@ivpress.com</a></em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Inter-Varsity Press, England</em></p>
<p class="copyright"><em class="italic">36 Causton Street<br/>London SW1P 4ST, England</em></p>
<p class="copyright"><em class="italic"><a class="www" href="http://www.ivpbooks.com" target="_blank">ivpbooks.com</a></em></p>
<p class="copyright"><em class="italic"><a class="www" href="mailto:ivp@ivpbooks.com">ivp@ivpbooks.com</a></em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">© 2021 by David E. Garland</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">David E. Garland has asserted his right under the Copyright, Designs and Patents Act, 1988, to be identified as Author of this work.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the publisher or the Copyright Licensing Agency.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">InterVarsity Press®, USA, is the book-publishing division of InterVarsity Christian Fellowship/USA® and a member movement of the International Fellowship of Evangelical Students. Website: <a class="www" href="http://www.intervarsity.org" target="_blank">intervarsity.org</a>.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Inter-Varsity Press, England, originated within the Inter-Varsity Fellowship, now the Universities and Colleges Christian Fellowship, a student movement connecting Christian Unions in universities and colleges throughout Great Britain, and a member movement of the International Fellowship of Evangelical Students. That historic association is maintained, and all senior IVP staff and committee members
subscribe to the UCCF Basis of Faith. Website: <a class="www" href="http://www.uccf.org.uk" target="_blank">www.uccf.org.uk</a>.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Unless otherwise stated, Scripture quotations are from the New Revised Standard Version of the Bible, Anglicized edition, copyright © 1989, 1995 by the Division of Christian Education of the National Council of the Churches of Christ in the USA, and used by permission. All rights reserved.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">First published 2021</em></p>
<p class="imprint_sp"><em class="italic">USA ISBN 978-1-5140-0354-1 (digital)</em></p>
<p class="imprint"><em class="italic">USA ISBN 978-1-5140-0353-4 (print)</em></p>
<p class="imprint"><em class="italic">UK ISBN 978-1-78974-312-8 (digital)</em></p>
<p class="imprint"><em class="italic">UK ISBN 978-1-78974-313-5 (print)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TNTC_Romans2.vue?2f000783